// extracted by mini-css-extract-plugin
module.exports = {"root":"why-free_root__1jitc","outer":"why-free_outer__lCaO4","inner":"why-free_inner__24MYv"};